import { render, staticRenderFns } from "./infoDrawer.vue?vue&type=template&id=2eced141&scoped=true"
import script from "./infoDrawer.vue?vue&type=script&lang=js"
export * from "./infoDrawer.vue?vue&type=script&lang=js"
import style0 from "./infoDrawer.vue?vue&type=style&index=0&id=2eced141&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eced141",
  null
  
)

export default component.exports